import React from "react";
import dynamic from 'next/dynamic'
const Carousel = dynamic(() => import('react-multi-carousel'), { 
  ssr: false 
})
import Image from "next/image";
import RightArrowBottom from "./RightArrowBottom";
import LeftArrowBottom from "./LeftArrowBottom";
import "react-multi-carousel/lib/styles.css";
import { urlForImage } from '~/lib/sanity.image';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 2,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 767, min: 375 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};
const prefix = '/systems/'
const SilderMulti = ({items}) => {
  return (
    <div className="parent">
        
      <Carousel
        responsive={responsive}
        autoPlay={false}
        swipeable={true}
        draggable={true}
        showDots={true}
        infinite={true}
        partialVisible={false}
        renderButtonGroupOutside={true}
        customLeftArrow={<LeftArrowBottom/>}
        customRightArrow={<RightArrowBottom />} 
        containerClass="spacer-carousel-container"
        dotListClass="spacer-custom-dot-list-style"
      >
        {items && (
          items.map((item, index) => {
            const firstImage = item.smallImage
  
            return (
              <div className="slider slider-margin" key={index}>
                <div className="imageWrapper">
                  {firstImage && (
                    <>
                        <Image
                          key={firstImage._id}
                          src={urlForImage(firstImage).url()}
                          alt={firstImage.title ? firstImage.title : "slider"}
                          width={0}
                          height={0}
                          sizes="100vw"
                          style={{ width: '100%', height: 'auto' }} 
                          className="h-full w-full object-cover"
                        />
                        <span className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                          <h2 className="text-4xl font-semibold text-background">{firstImage.title}</h2>
                      </span>
                      </>
                  )}                  
                </div>
                <h3 className="text-2xl font-semibold text-primary mt-10 mb-5">{item.title}</h3>
                <p className="text-xl text-primary line-clamp-3">{item.excerpt}</p>
                <a className="mt-2 font-bold underline float-end" href={prefix + item.slug.current}>More</a>
              </div>              
            );
          })
        )}
      </Carousel>
    </div>
  );
};
export default SilderMulti;
